import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7437f49e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "padding-right": "8px",
    "user-select": "none"
  }
}, "开启服务器时间:", -1));
const _hoisted_2 = {
  class: "dbt-picker-header-label"
};
const _hoisted_3 = {
  class: "dbt-range-picker"
};
const _hoisted_4 = {
  class: "dbt-picker dbt-picker-left"
};
const _hoisted_5 = {
  class: "dbt-picker-header"
};
const _hoisted_6 = ["onClick", "data-date"];
const _hoisted_7 = {
  class: "dbt-picker dbt-picker-right"
};
const _hoisted_8 = {
  class: "dbt-picker-header"
};
const _hoisted_9 = ["onClick", "data-date"];
const _hoisted_10 = {
  key: 0,
  class: "dbt-quick-selection"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 1,
  class: "dbt-time-range"
};
const _hoisted_13 = {
  key: 0,
  class: "datapanelTime"
};
const _hoisted_14 = {
  class: "datapanelTimeLabel"
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  key: 2,
  class: "deletion"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_switch = _resolveComponent("a-switch");
  const _component_a_row = _resolveComponent("a-row");
  const _component_SvgIcon = _resolveComponent("SvgIcon");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_time_picker = _resolveComponent("a-time-picker");
  const _component_a_popover = _resolveComponent("a-popover");
  return _openBlock(), _createBlock(_component_a_popover, {
    open: $setup.visible,
    "onUpdate:open": _cache[7] || (_cache[7] = $event => $setup.visible = $event),
    trigger: "click",
    getPopupContainer: trigger => trigger.parentNode,
    placement: $props.position
  }, {
    title: _withCtx(() => [$props.showHeader ? (_openBlock(), _createBlock(_component_a_row, {
      key: 0,
      class: "title-header"
    }, {
      default: _withCtx(() => [$props.showDynamic ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 8
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          class: _normalizeClass(["default-time-label", {
            'time-label': $setup.formData.dynamic == 0
          }]),
          onClick: _cache[0] || (_cache[0] = $event => $setup.handleDynamic(0)),
          style: {
            "margin-right": "16px"
          }
        }, " 静态时间 ", 2), _createElementVNode("span", {
          class: _normalizeClass(["default-time-label", {
            'time-label': $setup.formData.dynamic == 1
          }]),
          onClick: _cache[1] || (_cache[1] = $event => $setup.handleDynamic(1))
        }, " 动态时间 ", 2)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_a_col, {
        span: 8,
        class: "header-time-label"
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($setup.showTime), 1)]),
        _: 1
      }), $props.showUseServerTime ? (_openBlock(), _createBlock(_component_a_col, {
        key: 1,
        span: 8
      }, {
        default: _withCtx(() => [_hoisted_1, _createVNode(_component_a_switch, {
          size: "small",
          checked: $setup.formData.useServerTime,
          "onUpdate:checked": _cache[2] || (_cache[2] = $event => $setup.formData.useServerTime = $event),
          onChange: $setup.handleSwitchServer
        }, null, 8, ["checked", "onChange"])]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    content: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_SvgIcon, {
      iconClass: "dateArrow",
      onClick: $setup.handleStartLeftPanelYear
    }, null, 8, ["onClick"]), _createVNode(_component_SvgIcon, {
      iconClass: "dateArrow",
      onClick: $setup.handleStartLeftPanel
    }, null, 8, ["onClick"]), _createElementVNode("span", null, _toDisplayString($setup.startYearLabel) + "年", 1), _createElementVNode("span", null, _toDisplayString($setup.startMonthLabel) + "月", 1), _createVNode(_component_SvgIcon, {
      iconClass: "dateArrowRight",
      onClick: $setup.handleStartRightPanel,
      class: _normalizeClass({
        'disabled-arrow': $setup.dayjs(`${$setup.startYearLabel}-${$setup.startMonthLabel}-01`).add(1, 'month').startOf('month').valueOf() == $setup.dayjs(`${$setup.endYearLabel}-${$setup.endMonthLabel}-01`).valueOf()
      })
    }, null, 8, ["onClick", "class"]), _createVNode(_component_SvgIcon, {
      iconClass: "dateArrowRight",
      onClick: $setup.handleStartRightPanelYear,
      class: _normalizeClass({
        'disabled-arrow': $setup.startYearLabel + 1 > $setup.endYearLabel
      })
    }, null, 8, ["onClick", "class"])]), _createElementVNode("div", null, [_createVNode(_component_SvgIcon, {
      iconClass: "dateArrow",
      onClick: $setup.handleEndLeftPanelYear,
      class: _normalizeClass({
        'disabled-arrow': $setup.dayjs(`${$setup.startYearLabel}-${$setup.startMonthLabel}-01`).startOf('month').valueOf() >= $setup.dayjs(`${$setup.endYearLabel - 1}-${$setup.endMonthLabel}-01`).startOf('month').valueOf()
      })
    }, null, 8, ["onClick", "class"]), _createVNode(_component_SvgIcon, {
      iconClass: "dateArrow",
      onClick: $setup.handleEndLeftPanel,
      class: _normalizeClass({
        'disabled-arrow': $setup.dayjs(`${$setup.endYearLabel}-${$setup.endMonthLabel}-01`).add(-1, 'month').startOf('month').valueOf() == $setup.dayjs(`${$setup.startYearLabel}-${$setup.startMonthLabel}-01`).valueOf()
      })
    }, null, 8, ["onClick", "class"]), _createElementVNode("span", null, _toDisplayString($setup.endYearLabel) + "年", 1), _createElementVNode("span", null, _toDisplayString($setup.endMonthLabel) + "月", 1), _createVNode(_component_SvgIcon, {
      iconClass: "dateArrowRight",
      onClick: $setup.handleEndRightPanel
    }, null, 8, ["onClick"]), _createVNode(_component_SvgIcon, {
      iconClass: "dateArrowRight",
      onClick: $setup.handleEndRightPanelYear
    }, null, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.weekHeader, item => {
      return _openBlock(), _createElementBlock("span", {
        class: "dbt-picker-item",
        key: item
      }, _toDisplayString(item), 1);
    }), 128))]), _createElementVNode("div", {
      class: "dbt-picker-body",
      onMousemove: _cache[3] || (_cache[3] = (...args) => $setup.onMousemove && $setup.onMousemove(...args))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.leftWeekList, item => {
      var _$setup$formData$star, _$setup$formData$endT;
      return _openBlock(), _createElementBlock("span", {
        class: _normalizeClass(["dbt-picker-item", {
          'fisrt-select-day': `${item.year}${item.month}${item.day}` == $setup.startSelectDay,
          'end-select-day': `${item.year}${item.month}${item.day}` == $setup.endSelectDay,
          'hover-select-day': $setup.renderStyle(item.year, item.month, item.day),
          'start-end-day': `${item.year}${item.month}${item.day}` == ((_$setup$formData$star = $setup.formData.startTime) === null || _$setup$formData$star === void 0 ? void 0 : _$setup$formData$star.slice(0, 8)) || `${item.year}${item.month}${item.day}` == ((_$setup$formData$endT = $setup.formData.endTime) === null || _$setup$formData$endT === void 0 ? void 0 : _$setup$formData$endT.slice(0, 8)),
          'disabled-day': $setup.dayjs(`${$setup.startYearLabel}-${$setup.startMonthLabel}-01`).add(0, 'month').startOf('month').valueOf() > $setup.dayjs(`${item.year}${item.month}${item.day}`).valueOf() || $setup.dayjs(`${$setup.startYearLabel}-${$setup.startMonthLabel}-01`).add(1, 'month').startOf('month').valueOf() <= $setup.dayjs(`${item.year}${item.month}${item.day}`).valueOf() || $props.selectDateRange.length && ($setup.dayjs(`${item.year}${item.month}${item.day}`).add(0, 'day').startOf('day').valueOf() < $setup.dayjs($props.selectDateRange[0]).valueOf() || $setup.dayjs(`${item.year}${item.month}${item.day}`).add(0, 'day').startOf('day').valueOf() > $setup.dayjs($props.selectDateRange[1]).valueOf()),
          'range-day': $setup.renderSelectLeftStyle(item.year, item.month, item.day)
        }]),
        key: item.date,
        onClick: $event => $setup.handleSelectTime(item),
        "data-date": `${item.year}-${item.month}-${item.day}`
      }, _toDisplayString(item.day), 11, _hoisted_6);
    }), 128))], 32)])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.weekHeader, item => {
      return _openBlock(), _createElementBlock("span", {
        class: "dbt-picker-item",
        key: item
      }, _toDisplayString(item), 1);
    }), 128))]), _createElementVNode("div", {
      class: "dbt-picker-body",
      onMousemove: _cache[4] || (_cache[4] = (...args) => $setup.onMousemove && $setup.onMousemove(...args))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rightWeekList, item => {
      var _$setup$formData$endT2, _$setup$formData$star2;
      return _openBlock(), _createElementBlock("span", {
        class: _normalizeClass(["dbt-picker-item", {
          'fisrt-select-day': `${item.year}${item.month}${item.day}` == $setup.startSelectDay,
          'end-select-day': `${item.year}${item.month}${item.day}` == $setup.endSelectDay,
          'hover-select-day': $setup.renderStyle(item.year, item.month, item.day),
          'start-end-day': `${item.year}${item.month}${item.day}` == ((_$setup$formData$endT2 = $setup.formData.endTime) === null || _$setup$formData$endT2 === void 0 ? void 0 : _$setup$formData$endT2.slice(0, 8)) || `${item.year}${item.month}${item.day}` == ((_$setup$formData$star2 = $setup.formData.startTime) === null || _$setup$formData$star2 === void 0 ? void 0 : _$setup$formData$star2.slice(0, 8)),
          'disabled-day': $setup.dayjs(`${$setup.endYearLabel}-${$setup.endMonthLabel}-01`).add(0, 'month').startOf('month').valueOf() > $setup.dayjs(`${item.year}${item.month}${item.day}`).valueOf() || `${item.year}${item.month}${item.day}` > $setup.currentDay || $setup.dayjs(`${$setup.endYearLabel}-${$setup.endMonthLabel}-01`).add(1, 'month').startOf('month').valueOf() <= $setup.dayjs(`${item.year}${item.month}${item.day}`).valueOf() || $props.selectDateRange.length && ($setup.dayjs(`${item.year}${item.month}${item.day}`).add(0, 'day').startOf('day').valueOf() < $setup.dayjs($props.selectDateRange[0]).valueOf() || $setup.dayjs(`${item.year}${item.month}${item.day}`).add(0, 'day').startOf('day').valueOf() > $setup.dayjs($props.selectDateRange[1]).valueOf()),
          'range-day': $setup.renderSelectRightStyle(item.year, item.month, item.day)
        }]),
        key: item.date,
        onClick: $event => $setup.handleSelectTime(item),
        "data-date": `${item.year}-${item.month}-${item.day}`
      }, _toDisplayString(item.day), 11, _hoisted_9);
    }), 128))], 32)])])]), $props.showQuick ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.quickList, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.label,
        class: _normalizeClass(["quick-selection-item", {
          'quick-selection-item-select': item.recentDay == $setup.formData.recentDay && item.fromDayToDay == $setup.formData.fromDayToDay
        }]),
        onClick: $event => $setup.handleQuickTime(item)
      }, _toDisplayString(item.label), 11, _hoisted_11);
    }), 128))])) : _createCommentVNode("", true), $props.showTimeRange ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_a_input, {
      style: {
        "width": "138px"
      },
      value: $setup.dayjs($setup.formData.startTime).format('YYYY-MM-DD')
    }, null, 8, ["value"]), _createVNode(_component_a_time_picker, {
      style: {
        "width": "138px"
      },
      value: $setup.timeStart,
      "onUpdate:value": _cache[5] || (_cache[5] = $event => $setup.timeStart = $event),
      onChange: $setup.handleTimeChangeStart,
      allowClear: false
    }, null, 8, ["value", "onChange"]), _createVNode(_component_a_input, {
      style: {
        "width": "138px"
      },
      value: $setup.dayjs($setup.formData.endTime).format('YYYY-MM-DD')
    }, null, 8, ["value"]), _createVNode(_component_a_time_picker, {
      style: {
        "width": "138px"
      },
      value: $setup.timeEnd,
      "onUpdate:value": _cache[6] || (_cache[6] = $event => $setup.timeEnd = $event),
      onChange: $setup.handleTimeChangeEnd,
      allowClear: false
    }, null, 8, ["value", "onChange"])])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [$props.useType == 'datapanel' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [$props.showUseServerTime ? (_openBlock(), _createElementBlock("p", {
      key: 0,
      class: _normalizeClass({
        isServerTime: $setup.formData.useServerTime,
        serverTimeTip: true
      })
    }, _toDisplayString($setup.formData.useServerTime ? '服务器' : '客户端'), 3)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_14, _toDisplayString($setup.showTime), 1), _createVNode(_component_SvgIcon, {
      iconClass: "blueDownArrow",
      className: "blueDownArrow"
    })])) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: _normalizeClass(["showtimelabel", {
        redFrame: (!$setup.formData.startTime || !$setup.formData.endTime) && $props.isRequired,
        deletion_showtimelabel: $props.isdeletion,
        grey_showtimelabel: (!$setup.formData.startTime || !$setup.formData.endTime) && $props.isdeletion
      }])
    }, [$props.showUseServerTime ? (_openBlock(), _createElementBlock("p", {
      key: 0,
      class: _normalizeClass({
        isServerTime: $setup.formData.useServerTime,
        serverTimeTip: true
      })
    }, _toDisplayString($setup.formData.useServerTime ? '服务器' : '客户端'), 3)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($setup.showTime) + " ", 1), !$props.isdeletion ? (_openBlock(), _createElementBlock("span", _hoisted_15, [_createVNode(_component_SvgIcon, {
      iconClass: "dateIcon",
      className: "dateIcon"
    })])) : (_openBlock(), _createElementBlock("span", _hoisted_16, [_createVNode(_component_SvgIcon, {
      iconClass: "dateIcon",
      className: "deletion_dateIcon"
    }), _createVNode(_component_SvgIcon, {
      iconClass: "circleDelete",
      className: "deletion_circleDelete",
      onClick: _withModifiers($setup.deleteDate, ["stop"])
    }, null, 8, ["onClick"])]))], 2))]),
    _: 1
  }, 8, ["open", "getPopupContainer", "placement"]);
}